import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import MFTransfer from "./MFTransfer";
import TransferIn from "./TransferIn/TransferIn";
import ProfileHistory from "./ProfileHistory/ProfileHistory";
var MFTransferRouting = function (props) {
    useEffect(function () {
        props === null || props === void 0 ? void 0 : props.setHeaderLeftComponent(React.createElement("div", { className: "d-flex flex-column txt_white" },
            React.createElement("span", { className: "DMsanR_32_400" }, "Transfer-In: Mutual Funds"),
            React.createElement("span", { className: "d-flex align-items-center gap-1" },
                React.createElement("span", { className: "txt_manatee bg-gainsboro-white border-32 px-2 py-1 DMsanR_10_400" }, "ARN Transfer"),
                React.createElement("span", { className: "DMSanN_14_300" }, "Sync and transfer in client\u2019s mutual funds holdings"),
                " ")));
    }, []);
    return (React.createElement(Routes, null,
        React.createElement(Route, { index: true, element: React.createElement(MFTransfer, null) }),
        React.createElement(Route, { path: "/transfer-in", element: React.createElement(TransferIn, null) }),
        React.createElement(Route, { path: "/profile-history", element: React.createElement(ProfileHistory, null) })));
};
export default MFTransferRouting;
